export const IMAGE_MODULE_TEST_ID = {
  gridTransparent: 'grid-transparent',
  right: 'grid-right-align',
  left: 'grid-left-align',
};
